import React, { useEffect, useRef, useState } from "react";
import CompanyFilterData from "./CompanyFilterData";
import RightModal from "../../../components/Modal/RightModal";
import { initialCompanyFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";

const CompanyFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialCompanyFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleFilterChange = (value, name) => {
    let nameVal = name;
    if(name === 'owner_tags' && filterData?.tag_category === 'without'){
        nameVal = 'owner_without_tags'
    }
    onSetFilterData({ ...filterData, [nameVal]: value });
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      company_name: value?.company_name ?? "",
      primaryphone: value?.phone ?? "",
      streetaddress: value?.street_address ?? "",
      city: value?.city ?? "",
      state: value?.state ?? "",
      zip: value?.zip_code ?? "",
      website: value?.website ?? "",
      taxrecord: value?.tax_record_sent ?? "",
      taxrecordsentdate: value?.tax_record_sent_date ?? "",
      taxrecordsentSdate: value?.tax_record_start_date ?? "",
      taxrecordsentEdate: value?.tax_record_end_date ?? "",
      tags: value?.tags ?? [],
      last_contact: value?.last_contact ?? "date",
      lastContactSentDate: value?.lastContactSentDate ?? "",
      lastContactSentSdate: value?.lastContactSentSdate ?? "",
      lastContactSentEdate: value?.lastContactSentEdate ?? "",
      date_category: value?.date_category ?? "days",
      within_last_day: filterData?.within_last_day,
      longer_than_day: filterData?.longer_than_day,
      count: value?.count ?? "",
      start_count: value?.start_count ?? "",
      end_count: value?.end_count ?? "",
      property: value?.property ?? "",
      owner_without_tags: value?.owner_without_tags,
      owner_tags: value?.ownerTags,

    };
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  const saveSearchFilterData = {
    company_name: filterData?.company_name,
    phone: filterData?.primaryphone,
    street_address: filterData?.streetaddress,
    city: filterData?.city,
    state: filterData?.state,
    zip_code: filterData?.zip,
    website: filterData?.website,
    tax_record_sent: filterData?.taxrecord,
    tax_record_sent_date: filterData?.taxrecordsentdate,
    tax_record_start_date: filterData?.taxrecordsentSdate,
    tax_record_end_date: filterData?.taxrecordsentEdate,
    tags: filterData?.tags,
    last_contact: filterData?.last_contact,
    lastContactSentDate: filterData?.lastContactSentDate,
    lastContactSentSdate: filterData?.lastContactSentSdate,
    lastContactSentEdate: filterData?.lastContactSentEdate,
    date_category: filterData?.date_category,
    within_last_day: filterData?.within_last_day,
    longer_than_day: filterData?.longer_than_day,
    count: filterData?.count,
    start_count: filterData?.start_count,
    end_count: filterData?.end_count,
    property: filterData?.property,
    owner_without_tags: filterData?.owner_without_tags,
    owner_tags: filterData?.ownerTags,
  };

  return (
    <div>
      <SavedFilterComponent
        from="company"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialCompanyFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
          // onSetFilterData(initialCompanyFilterData);
        }}
        ref={dropdownRef}
        title={"Filter"}
        desc={"Enter company information."}
        onFilter={handleFilter}
        from="company"
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <CompanyFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} handleFilterChange={handleFilterChange} onSetFilterData={onSetFilterData} />
      </RightModal>
    </div>
  );
};

export default CompanyFilter;
